import { animate, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { SaleStatus } from '@enums/enums';
import { BffApiService } from '@shared/bff-api.service';
import { errorGeneral, SnackBarService, successGeneral } from 'src/app/shared/service/snack-bar.service';

@Component({
  selector: 'app-order-line',
  templateUrl: './order-line.component.html',
  styleUrls: ['./order-line.component.scss'],
  imports: [CommonModule, ReactiveFormsModule],
  animations: [
    trigger('AnimationTrigger0', [
      transition(':enter', [
        style({ opacity: 0, transform: 'scale(.95)' }),
        animate('100ms ease-out', style({ opacity: 1, transform: 'scale(1)' })),
      ]),
      transition(':leave', [
        style({ opacity: 1, transform: 'scale(1)' }),
        animate('75ms ease-in', style({ opacity: 0, transform: 'scale(.95)' })),
      ]),
    ]),
  ],
})
export class OrderLineComponent {
  @Input() order: any;
  isMenu = false;
  isDetail = false;
  editStatus: boolean = false;
  protected readonly saleStatus = SaleStatus;

  statusForm;

  constructor(private bff: BffApiService, private fb: FormBuilder, private snack: SnackBarService) {
    this.statusForm = this.fb.group({
      status: [null, Validators.required],
    });
  }

  toggleMenu() {
    this.isMenu = !this.isMenu;
  }

  toggleDetails() {
    this.isDetail = !this.isDetail;
    console.debug(this.order);
  }

  isPickupDeliveryType() {
    return this.order.deliveryType == 'PICKUP';
  }

  getStatusClass(status: SaleStatus): string[] {
    const statusStyles: Record<string, string[]> = {
      WAITING_MONEY: ['text-gray-700', 'bg-gray-50', 'ring-gray-600/20'],
      REFUNDED: ['text-grey-700', 'bg-grey-50', 'ring-grey-600/20'],
      PAID: ['text-green-700', 'bg-green-50', 'ring-green-600/20'],
      SENT: ['text-green-700', 'bg-green-50', 'ring-green-600/20'],
      PENDING: ['text-orange-700', 'bg-orange-50', 'ring-orange-600/20'],
      RETURNED: ['text-orange-700', 'bg-orange-50', 'ring-orange-600/20'],
      RETRIEVED: ['text-blue-700', 'bg-blue-50', 'ring-blue-600/20'],
      CLOSED: ['text-blue-700', 'bg-blue-50', 'ring-blue-600/20'],
    };

    return statusStyles[status] || [];
  }

  toggleStatus() {
    this.editStatus = !this.editStatus;
  }

  updateStatus(newStatus: any) {
    this.order.status = newStatus.status;
  }

  saveStatus(order_id: any) {
    if (this.statusForm.invalid) {
      this.snack.snack(errorGeneral);
      return;
    }
    // The status must be within this list :
    // WAITING_MONEY,PAID,PENDING,SENT,RETRIEVED,RETURNED,REFUNDED,CLOSED
    this.bff.putOrder(order_id, this.statusForm.value).subscribe((data) => {
      this.snack.snack(successGeneral);
      this.toggleStatus();
      this.updateStatus(this.statusForm.value);
    });
  }
}
